import React from 'react';
import CalendarWeek from './calendarWeek.js';
import AuthService from '../../Services/authService.js';
import TimeSheetEntryService from '../../Services/timeSheetEntryService.js';
import TaskService from '../../Services/taskService.js';
import TimeSheetEntryEditor from './timeSheetEntryEditor.js';
import { dateTimeHelper } from '../../Helpers/datetimeHelper.js';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import Select from 'react-select';
import timesheet from './timesheet.module.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js';
import dsSelectStyles from '../../Elements/InputComponents/BaseInputs/Selectors/reactSelectDsStyles';
import ListView from './ListView.js';
import TimeSheetEntry from '../../Domain/TimeSheetEntry.js';
import en from 'date-fns/locale/en-GB';
import CookieHelper from '../../Helpers/cookieHelper.js';
import ErrorMessage from '../../Elements/ErrorMessage.js';
import UserService from '../../Services/userService.js';
import FaIcon from '../../Elements/FaIcon.js';
import UserGuideTitle from '../../Elements/UserGuideTitle';
import UsageRate from './UsageRate.js';
import CustomDateInput from '../../Elements/InputComponents/BaseInputs/CustomDateInput';
import TimesheetHelper from '../../Helpers/ModelHelpers/TimesheetHelper.js';

export default class Calendar extends React.Component {
  constructor(props) {
    super(props);
    const authService = AuthService.getInstance();
    const tsUser = authService.GetTimesheetUser();

    this.state = {
      howManyDaysToShow: parseInt(CookieHelper.getCookie('howManyDaysToShow', '5')),
      selectedDate: dateTimeHelper.getMonday(new Date()),
      timeSheetEntryList: [],
      selectedTimesheetEntry: '',
      // officeId: authService.GetLoggedInUser().officeId,
      officeid: UserService.GetOfficeIdOfLoggedInUser(),
      taskList: [{ taskId: -1, name: 'Loading...' }],
      listView: false,
      loading: false,
      userId: tsUser ? tsUser.userId : -1,
      loggedInUserId: tsUser ? tsUser.userId : -1,
      userOptions: [],
    };

    this._child = React.createRef();
  }

  componentDidMount() {
    if (this.state.loggedInUserId === -1) return;
    AuthService.getInstance().listenSwitchUserEvent(this.RefreshEntryCallback);
    this.loadTimesheetEntries(this.state.selectedDate);
    this.loadTasks();
    this.loadUsers();
    //$('[data-toggle="tooltip"]').tooltip({'placement': 'bottom'});
  }

  componentWillUnmount() {
    const authService = AuthService.getInstance();
    authService.unlistenSwitchUserEvent(this.RefreshEntryCallback);
  }

  RefreshEntryCallback = () => {
    this.RefreshEntryList();
  };

  handleSelectedDateChange(date) {
    const selectedDate = dateTimeHelper.getMonday(date);
    this.loadTimesheetEntries(selectedDate);
    this.setState({ selectedDate });
  }

  changeListView() {
    this.setState({
      listView: !this.state.listView,
    });
  }

  addNewEntry() {
    const actualTimeMinutes = dateTimeHelper.convertTimeToMinutes(
      `${new Date().getHours()}:${new Date().getMinutes()}`
    );
    const convertedFirstSelectedDate = dateTimeHelper.getFormattedDate(new Date(), '.');
    const convertedLastSelectedDate = dateTimeHelper.getFormattedDate(new Date(), '.');
    const convertedFirstSelectedTime = dateTimeHelper.convertMinutesToTime(actualTimeMinutes);
    const convertedLastSelectedTime = dateTimeHelper.convertMinutesToTime(actualTimeMinutes + 5);

    const newEntry = new TimeSheetEntry(
      convertedFirstSelectedDate,
      convertedLastSelectedDate,
      convertedFirstSelectedTime,
      convertedLastSelectedTime,
      '',
      ''
    );
    this.newEntryCallback(newEntry);
  }

  showPreviousWeek() {
    const selectedDate = dateTimeHelper.getMonday(this.state.selectedDate);
    const newdate = dateTimeHelper.addDaysToDate(selectedDate, -7);

    this.loadTimesheetEntries(newdate);
    this.setState({ selectedDate: newdate });
  }

  showNextWeek() {
    const selectedDate = dateTimeHelper.getMonday(this.state.selectedDate);

    const newdate = dateTimeHelper.addDaysToDate(selectedDate, 7);
    this.loadTimesheetEntries(newdate);
    this.setState({ selectedDate: newdate });
  }

  showCurrentWeek() {
    const newdate = new Date();
    this.loadTimesheetEntries(newdate);
    this.setState({ selectedDate: newdate });
  }

  newEntryCallback = (selectedTimesheetEntry) => {
    if (selectedTimesheetEntry.id && this.state.userId !== this.state.loggedInUserId) {
      this.setState({ selectedTimesheetEntry });
      return;
    }

    if (this.state.selectedTimesheetEntry === '') {
      if (this.state.userId === this.state.loggedInUserId) {
        this.setState({ selectedTimesheetEntry });
        return;
      }
      ErrorMessage.SetWarning('You can only add new entries for yourself.');
    }
  };

  handleHowManyDaysToShowChange(e) {
    CookieHelper.setCookie('howManyDaysToShow', e.value);
    this.setState({ howManyDaysToShow: e.value }, () => this.RefreshEntryList());
  }

  handleUserChange(e) {
    this.setState({ userId: e.value }, () => this.RefreshEntryList());
  }

  closeEditorPopup() {
    this.setState({ selectedTimesheetEntry: '' });
    try {
      this._child.current.ResetTimeFrameSelection();
    } catch (err) {
      ErrorMessage.LogDevInfo(err, 'calendar.js 142', ErrorMessage.NotProd);
    }
  }

  loadTimesheetEntries(selectedDate) {
    selectedDate = dateTimeHelper.toYYYYsMMsDD(selectedDate);
    this.setState({ loading: true, timeSheetEntryList: [] });
    const selectedDateAsDate = new Date(dateTimeHelper.toYYYYsMMsDD(selectedDate));
    TimeSheetEntryService.GetTimeSheetEntries(selectedDateAsDate, this.state.userId)
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
          this.setState({ loading: false });
          return;
        }
        const convertedEntries = TimeSheetEntryService.ConvertDBTimesheetEntries(result);
        this.setState({
          timeSheetEntryList: convertedEntries,
          loading: false,
        });
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('CLD281');
        this.setState({ loading: false });
      });
  }

  loadUsers() {
    UserService.GetUserListForTimesheet().then((response) => {
      this.setState({ userOptions: this.userOptionsFunction(response) });
    });
  }

  userOptionsFunction(userList) {
    return userList.map((user) => {
      return { value: user.userId, label: user.name };
    });
  }

  loadTasks() {
    TaskService.GetTaskList()
      .then((result) => {
        this.setState({ taskList: result });
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('CLD314');
        this.setState({ loading: false });
      });
  }

  RefreshEntryList() {
    this.loadTimesheetEntries(this.state.selectedDate);
  }

  // Decides whether the editor opens editable or read-only for the selected entry.
  // Vendor-linked entries are always read-only. PTO entries (taskId 106) are editable
  // by HR/Admin for anyone; regular users can edit only their own, manually created
  // PTO (not the ones auto-created by the BambooHR sync). Everything else stays
  // "own timesheet only".
  isEntryEditingEnabled(entry) {
    if (!entry) return false;
    if (entry.freelancerLineItemId) return false;
    if (entry.taskId === 106) {
      //106 is the taskId for PTO
      if (AuthService.HasRole('HR')) return true;
      return this.state.userId === this.state.loggedInUserId && !entry.isBambooHrCreated;
    }
    return this.state.userId === this.state.loggedInUserId;
  }

  renderNoTsUserError() {
    return (
      <div className='row'>
        <div className='col'>
          <div>You are not registered as a timesheet user. Please contact the office manager.</div>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.loggedInUserId === -1) {
      return this.renderNoTsUserError();
    }
    const selectedEntry = this.state.selectedTimesheetEntry;
    const timesheetEntryEditorComponent =
      selectedEntry === '' ? null : (
        <TimeSheetEntryEditor
          timesheetEntry={JSON.parse(JSON.stringify(selectedEntry))}
          taskList={this.state.taskList}
          closeEditorPopup={this.closeEditorPopup.bind(this)}
          RefreshEntryList={this.RefreshEntryList.bind(this)}
          existingTimesheetEntries={this.state.timeSheetEntryList}
          editingEnabled={this.isEntryEditingEnabled(selectedEntry)}
          isJiraWorklog={!!(selectedEntry && selectedEntry.jiraWorklogId)}
          isVendorLinked={!!(selectedEntry && selectedEntry.freelancerLineItemId)}
          isBambooPtoLocked={
            !!(
              selectedEntry &&
              selectedEntry.taskId === 106 && //106 is the taskId for PTO
              selectedEntry.isBambooHrCreated &&
              !AuthService.HasRole('HR')
            )
          }
        />
      );
    const howManyDaysToShow = [5, 7].includes(this.state.howManyDaysToShow) ? this.state.howManyDaysToShow : 5;

    return (
      <div className='at-shell'>
        {this.renderPageHead()}
        {this.renderIconBar(howManyDaysToShow)}
        {this.renderWeekdaysRow(howManyDaysToShow)}
        {timesheetEntryEditorComponent}
      </div>
    );
  }

  renderWeekdaysRow(howManyDaysToShow) {
    return (
      <div
        className='row'
        id='divCalendarWeekRow'
      >
        <div className={`col ${timesheet.nopadding}`}>
          {this.state.listView ? (
            <ListView
              selectedDate={this.state.selectedDate}
              selectedUserId={this.state.userId}
            />
          ) : (
            <CalendarWeek
              weekNumber={dateTimeHelper.getWeekOfYearForTimeSheet(this.state.selectedDate)}
              year={dateTimeHelper.getYearForTimeSheet(this.state.selectedDate)}
              howManyDaysToShow={howManyDaysToShow}
              timeSheetEntryList={this.state.timeSheetEntryList}
              newEntryCallback={this.newEntryCallback}
              selectedDate={this.state.selectedDate}
              ref={this._child}
              userId={this.state.userId}
            />
          )}
        </div>
      </div>
    );
  }

  // Sums the real span of each entry loaded for the week. The clock-time-only arithmetic this
  // replaced read startTime/endTime, which stay set to the full original span on both display
  // rows of an entry that crosses midnight — so such an entry was counted twice, and as a
  // negative, because its end time reads as earlier in the day than its start time.
  getWeekTotalHours() {
    const entries = TimesheetHelper.GetDistinctEntries(this.state.timeSheetEntryList);
    const minutes = entries.reduce((sum, entry) => sum + TimesheetHelper.GetEntryDurationInMinutes(entry), 0);

    return Math.round((minutes / 60) * 100) / 100;
  }

  renderPageHead() {
    const total = this.getWeekTotalHours();
    const totalLabel = (Number.isInteger(total) ? total : total.toFixed(2).replace(/\.?0+$/, '')) + 'h';
    return (
      <div className='page-head'>
        <div className='page-title'>
          <span className='eq-mark'>
            <span></span>
            <span></span>
          </span>
          <div>
            <div className='eyebrow'>Time &amp; activity</div>
            <h1>
              <UserGuideTitle title='Activity Tracker' />
            </h1>
          </div>
        </div>
        <div className='at-actions'>
          <div className='count-pill at-weektotal'>
            <b>{totalLabel}</b>
            <span>this week</span>
          </div>
          <div className='divider'></div>
          <button
            className='btn primary'
            onClick={() => this.addNewEntry()}
          >
            <FaIcon iconName='fa-regular fa-plus-square' /> New entry
          </button>
        </div>
      </div>
    );
  }

  renderIconBar(howManyDaysToShow) {
    const isToday =
      dateTimeHelper.getMonday(new Date()).getTime() === dateTimeHelper.getMonday(this.state.selectedDate).getTime();
    return (
      <div className='at-toolbar'>
        <div className='at-tg'>
          <button
            className={'icon-btn at-today' + (isToday ? ' here' : '')}
            title='Jump to today'
            onClick={this.showCurrentWeek.bind(this)}
          >
            <FaIcon iconName='fa-solid fa-igloo' />
          </button>
          <button
            className={'icon-btn' + (this.state.loading ? ' spinning' : '')}
            title='Refresh'
            onClick={this.RefreshEntryList.bind(this)}
          >
            <FaIcon iconName='fa-solid fa-refresh' />
          </button>
        </div>
        <div className='divider'></div>
        <div className='at-nav'>
          <button
            className='icon-btn'
            title='Previous week'
            onClick={this.showPreviousWeek.bind(this)}
          >
            <FaIcon iconName='fa-solid fa-chevron-left' />
          </button>
          <div className='at-weeklabel'>
            <DatePicker
              selected={this.state.selectedDate}
              selectsStart
              onChange={this.handleSelectedDateChange.bind(this)}
              calendarClassName='ds-datecal'
              customInput={<CustomDateInput />}
              locale={en}
            />
          </div>
          <button
            className='icon-btn'
            title='Next week'
            onClick={this.showNextWeek.bind(this)}
          >
            <FaIcon iconName='fa-solid fa-chevron-right' />
          </button>
        </div>
        <div className='sp'></div>
        {this.state.userId !== this.state.loggedInUserId && (
          <UsageRate
            userId={this.state.userId}
            selectedDate={this.state.selectedDate}
            entryList={this.state.timeSheetEntryList}
          />
        )}
        <Select
          className='at-user-select'
          classNamePrefix='atsel'
          options={this.state.userOptions}
          onChange={this.handleUserChange.bind(this)}
          styles={dsSelectStyles}
          menuPlacement='auto'
          menuPortalTarget={typeof document !== 'undefined' ? document.body : null}
          value={this.state.userOptions.find((d) => d.value === this.state.userId)}
        />
        <div
          className='at-seg'
          role='group'
          aria-label='Range'
        >
          <button
            className={howManyDaysToShow === 5 ? 'on' : ''}
            onClick={() => this.handleHowManyDaysToShowChange({ value: 5 })}
          >
            Weekdays
          </button>
          <button
            className={howManyDaysToShow === 7 ? 'on' : ''}
            onClick={() => this.handleHowManyDaysToShowChange({ value: 7 })}
          >
            Whole week
          </button>
        </div>
        <div
          className='at-seg'
          role='group'
          aria-label='View'
        >
          <button
            className={!this.state.listView ? 'on' : ''}
            onClick={() => this.state.listView && this.changeListView()}
            title='Calendar view'
          >
            <FaIcon iconName='fa-solid fa-table-cells' /> Grid
          </button>
          <button
            className={this.state.listView ? 'on' : ''}
            onClick={() => !this.state.listView && this.changeListView()}
            title='List view'
          >
            <FaIcon iconName='fa-solid fa-list' /> List
          </button>
        </div>
      </div>
    );
  }
}
